export default "__VITE_ASSET__ac9d9150__"